import * as React from "react";
import { useScale } from "./scale";
import { getDeviceModel, SPC_MODEL } from "@/lib/androidBridge";
import { COLOR, FW } from "@/ui/tokens";

export const HEADER = {
    H: 80,
    LPAD: 56,
    RPAD: 56,
    TPAD: 41,
    TITLE_FZ: 38,
    ICON: 60,
} as const;

export const withBase = (p: string) =>
    (import.meta.env.BASE_URL || "./") + p.replace(/^\/+/, "");

type HeaderProps = {
    title: string;
    icon?: string;
    backIcon?: string;
    onBack?: () => void;
    onTitleClick?: () => void;
    onIconClick?: () => void;
    right?: React.ReactNode;
    style?: React.CSSProperties;
};

export function Header({
                           title,
                           icon,
                           backIcon,
                           onBack,
                           onTitleClick,
                           onIconClick,
                           right,
                           style,
                       }: HeaderProps) {
    const { s, px } = useScale();
    const isSpc = React.useMemo(() => getDeviceModel() === SPC_MODEL, []);
    const titleFz = `${s(HEADER.TITLE_FZ) + (isSpc ? 5 : 0)}px`;
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",           // 텍스트 수직 중앙 정렬
                paddingLeft: px(HEADER.LPAD),
                paddingRight: px(HEADER.RPAD),
                paddingTop: px(HEADER.TPAD),    // 위 여백
                paddingBottom: px(16),          // 아래 여백 조금만 (원하는 만큼 조절)
                boxSizing: "border-box",
                width: "100%",
                ...style,
            }}
        >
            {onBack && backIcon && (
                <button
                    onClick={onBack}
                    aria-label="뒤로 가기"
                    style={{
                        lineHeight: 0,
                        marginRight: px(12),
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    <img
                        src={backIcon}
                        alt=""
                        style={{ width: px(48), height: px(48), display: "block" }}
                    />
                </button>
            )}

            {/* 제목: 클릭 가능하게 버튼으로 */}
            {onTitleClick ? (
                <button
                    onClick={onTitleClick}
                    style={{
                        fontSize: titleFz,
                        fontWeight: FW.extraBold,
                        color: COLOR.text,
                        background: "transparent",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                    }}
                >
                    {title}
                </button>
            ) : (
                <span
                    style={{ fontSize: titleFz, fontWeight: FW.extraBold, color: COLOR.text }}
                >
          {title}
        </span>
            )}

            {/* 아이콘: 클릭 가능하게 버튼으로 */}
            {icon && (
                <button
                    onClick={onIconClick || onTitleClick}
                    aria-label="헤더 아이콘"
                    style={{
                        background: "transparent",
                        border: "none",
                        lineHeight: 0,
                        marginLeft: px(12),
                        cursor: onIconClick || onTitleClick ? "pointer" : "default",
                    }}
                >
                    <img
                        src={icon}
                        alt=""
                        style={{ width: px(HEADER.ICON), height: px(HEADER.ICON), display: "block" }}
                    />
                </button>
            )}

            {/* 우측 영역 */}
            {right && <div style={{ marginLeft: "auto" }}>{right}</div>}
        </div>
    );
}
